module.exports = __webpack_public_path__ + "img/doinsport-logo.8dd8c303.svg";